import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pgm-payroll" }
const _hoisted_2 = { class: "payroll-tabs-wrapper" }
const _hoisted_3 = { class: "tabs-header-container" }
const _hoisted_4 = { class: "tab-magam-btn" }
const _hoisted_5 = { class: "payroll-window" }

import TabYoboWage from "@/components/wage/TabYoboWage.vue";
import TabSabokWage from "@/components/wage/TabSabokWage.vue";
import MagamBtn from "@/components/wage/MagamBtn.vue";
import { ref, computed, watch, nextTick, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmPayroll',
  setup(__props) {

const route = useRoute();
const store = useStore();

const activeTab = ref<string>("yobo");
const tabSabokWageRef = ref<any>(null);
const tabYoboWageRef = ref<any>(null);

// 마감 상태
const isMagam = ref(false);

// 마감 상태 변경 핸들러
const handleMagamStatusChanged = (status: boolean) => {
  isMagam.value = status;
};

// TabSabokWage의 데이터를 computed로 가져오기
const sabokStaffData = computed(() => {
  if (!tabSabokWageRef.value) return [];
  return tabSabokWageRef.value.staffData || [];
});

const sabokStaffSettings = computed(() => {
  if (!tabSabokWageRef.value) return {};
  return tabSabokWageRef.value.staffSettings || {};
});

// TabYoboWage의 데이터를 computed로 가져오기 (마감 버튼용)
const yoboData = computed(() => {
  if (!tabYoboWageRef.value) return [];
  return tabYoboWageRef.value.groupedMemberData || [];
});

const yoboLebYm = computed(() => {
  if (!tabYoboWageRef.value) return '';
  return tabYoboWageRef.value.lebYm || '';
});

const yoboTaxData = computed(() => {
  if (!tabYoboWageRef.value) return null;
  return tabYoboWageRef.value.taxData || null;
});

const yoboSettingsData = computed(() => {
  if (!tabYoboWageRef.value) return [];
  return tabYoboWageRef.value.settingsData || [];
});

// 쿼리 파라미터에서 연도와 월을 읽어서 YearMonthSelector에 설정
onMounted(() => {
  const year = route.query.year as string;
  const month = route.query.month as string;
  
  if (year && month) {
    // YYYYMM 형식으로 변환
    const yearMonth = `${year}${month.padStart(2, '0')}`;
    // store에 설정하여 TabYoboWage와 TabSabokWage의 YearMonthSelector가 자동으로 업데이트되도록 함
    store.commit('setLebYm', yearMonth);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_tabs, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                  class: "payroll-tabs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, {
                      value: "staff",
                      class: "payroll-tab"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "tab-icon" }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-account-tie", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tab-text" }, "센터장・사회복지사 급여", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, {
                      value: "yobo",
                      class: "payroll-tab"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "tab-icon" }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-account-group", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tab-text" }, "요양보호사 급여", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(MagamBtn, {
                    groupedMemberData: yoboData.value,
                    lebYm: yoboLebYm.value,
                    taxData: yoboTaxData.value,
                    settingsData: yoboSettingsData.value,
                    sabokStaffData: sabokStaffData.value,
                    sabokStaffSettings: sabokStaffSettings.value,
                    onMagamStatusChanged: handleMagamStatusChanged
                  }, null, 8, ["groupedMemberData", "lebYm", "taxData", "settingsData", "sabokStaffData", "sabokStaffSettings"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(TabSabokWage, {
                  ref_key: "tabSabokWageRef",
                  ref: tabSabokWageRef,
                  isMagam: isMagam.value
                }, null, 8, ["isMagam"])
              ], 512), [
                [_vShow, activeTab.value === 'staff']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(TabYoboWage, {
                  ref_key: "tabYoboWageRef",
                  ref: tabYoboWageRef,
                  "sabok-staff-data": sabokStaffData.value,
                  "sabok-staff-settings": sabokStaffSettings.value,
                  isMagam: isMagam.value
                }, null, 8, ["sabok-staff-data", "sabok-staff-settings", "isMagam"])
              ], 512), [
                [_vShow, activeTab.value === 'yobo']
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})